module.exports = __webpack_public_path__ + "components/promo-app/static/app-mobile-bg-a43a0a5eda1eb4d9b3a145981ec08cc9.jpg";